import MessageTip from "components/SignIn/MessageTip";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { STATUS } from "../../../../constants";
import firebaseService from "../../../../services/firebase";

const { DEFAULT, SUCCEED, FAILED, LOADING } = STATUS;

export const EMAIL_SENT_STATUS_MAPPING = {
  [STATUS.SUCCEED]: {
    className: "is-success",
    message:
      "We have just sent a verification email to your inbox. Please click the link in the email to verify your email address. Please also check your SPAM folder if the email is not in your inbox.",
  },
  [STATUS.FAILED]: {
    className: "is-danger",
    message: "Failed to send the verification email. Please try again",
  },
};

const EmailVerification = ({ setIsEmailVerified }) => {
  const history = useHistory();
  const [verifyStatus, setVerifyStatus] = useState({
    status: DEFAULT,
  });
  const currentUser = firebaseService.currentUser();

  const handleVerifyEmail = async () => {
    if (verifyStatus.status === LOADING) {
      return;
    }

    setVerifyStatus({
      status: LOADING,
    });

    try {
      await currentUser.sendEmailVerification({ url: `${process.env.REACT_APP_BASE_URL}/` });
      setVerifyStatus({
        status: SUCCEED,
      });
    } catch (error) {
      setVerifyStatus({
        status: FAILED,
        error: `Failed to send verify email to your email box${
          error.message ? `, the error might be ${error.message}` : ""
        }`,
      });
    }
  };

  const handleNext = () => {
    history.push("/");
  };

  return (
    <form className="public-secure-file-form" onSubmit={(event) => event.preventDefault()}>
      <div className="public-secure-file-notice">
        <i className="fas fa-envelope" aria-hidden="true" />
        <p>We need to verify your email address before setting up SMS multi-factor authentication for your account.</p>
      </div>
      <p className="public-secure-file-document-label">Step 1: Verify your email address</p>
      <button
        className={`public-secure-file-button public-secure-file-button--primary ${
          verifyStatus.status === LOADING ? "is-loading" : ""
        }`}
        type="button"
        onClick={handleVerifyEmail}
      >
        Send verification email
      </button>
      <MessageTip statusObj={verifyStatus} mapping={EMAIL_SENT_STATUS_MAPPING} />
      {verifyStatus.status === SUCCEED && (
        <>
          <p className="is-size-7 has-text-info">
            Please click the button below to sign in again after you verified your email.
          </p>
          <button className="public-secure-file-button" type="button" onClick={handleNext}>
            Back to Sign In
          </button>
        </>
      )}
    </form>
  );
};

export default EmailVerification;
